import { Team__Cerveceras } from "../teams/Cerveceras";
import { Team__Omega } from "../teams/Omega";
import { Team__Potras } from "../teams/Potras";
import { Team__Abejas } from "../teams/Abejas";

const Abejas = {
  team: Team__Abejas,
  playingPlayers: [],

  goals: 54,
  penaltyGoals: 0,
  isWinner: false,
};

const Omega = {
  team: Team__Omega,
  playingPlayers: [],

  goals: 48,
  penaltyGoals: 0,
  isWinner: false,
};

const Cerveceras = {
  team: Team__Cerveceras,
  playingPlayers: [],

  goals: 30,
  penaltyGoals: 0,
  isWinner: false,
};

const Potras = {
  team: Team__Potras,
  playingPlayers: [],

  goals: 27,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada5 = {
  jornadaPosition: 5,
  matches: [
    {
      team1: Abejas,
      team2: Potras,

      isCompleted: true,
      isPlaying: false,
      day: "Viernes",
      date: "2026-07-31",
      time: "11:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Omega,
      team2: Cerveceras,

      isCompleted: true,
      isPlaying: false,
      day: "Viernes",
      date: "2026-07-31",
      time: "12:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
